export default "__VITE_ASSET__f003bbc8__"